import {
  Avatar,
  Center,
  ChakraProps,
  Flex,
  HStack,
  Spinner,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import startCase from "lodash/startCase";
import { PropsWithChildren } from "react";
import { IntegrationWithLogo } from "../../IntegrationsModal.utils";

const ProviderRoot = ({
  children,
  ...props
}: PropsWithChildren<StackProps>) => {
  return (
    <VStack
      p="3"
      w="100%"
      spacing="3"
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRadius="lg"
      {...props}
    >
      {children}
    </VStack>
  );
};

const ProviderHeader = ({
  integration,
  color = "whiteAlpha.700",
  isLoading,
  children,
}: PropsWithChildren<{
  integration: IntegrationWithLogo;
  color?: ChakraProps["color"];
  isLoading?: boolean;
}>) => {
  return (
    <HStack w="100%" spacing="3">
      <Avatar
        height="2.25rem"
        width="2.25rem"
        src={integration.logoUrl}
        ignoreFallback
      />

      <Text fontSize="xl" color={color}>
        {startCase(integration.provider.toLowerCase())}
      </Text>

      <Center>{isLoading && <Spinner size="sm" />}</Center>

      <Flex flex="1" justifyContent="flex-end">
        {children}
      </Flex>
    </HStack>
  );
};

export const ProviderCard = {
  Root: ProviderRoot,
  Header: ProviderHeader,
};
